import { CORE_SEAT_LEVEL_TO_API_NAME, getProductForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { NO_PROMOTION, promotionKeys } from 'self-service-api/constants/Promotions';
import { isProductVersion, isQuantityPackDetails } from './typeguards';
export const getAllEligiblePromotions = ({
  promotions
}) => {
  if (!promotions) return [];
  const allPromotions = Object.values(promotions.productsEligibleForDirectPromotions || {});
  const uniquePromotions = {};
  for (const promotion of allPromotions) {
    for (const versionSpecificPromotion of Object.values(promotion)) {
      const {
        eligiblePromotion,
        eligiblePromotionId
      } = versionSpecificPromotion;
      if (eligiblePromotion && eligiblePromotion !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotion] = true;
      }

      // HSFS_SEED_V3 is only returned in eligiblePromotionId field
      if (eligiblePromotionId && eligiblePromotionId !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotionId] = true;
      }
    }
  }
  return Object.keys(uniquePromotions);
};
export const getOffersMap = ({
  promotions: {
    offersById
  }
}) => offersById;
export const getIsHsfxEligible = ({
  promotions
}) => {
  const eligiblePromotions = getAllEligiblePromotions({
    promotions
  });
  return eligiblePromotions.includes(promotionKeys.HSFS_SEED_V2) || eligiblePromotions.includes(promotionKeys.HSFS_SEED_V3) || eligiblePromotions.includes(promotionKeys.HSFS_SERIES_A_V2) || eligiblePromotions.includes(promotionKeys.HSFX_ENTREPRENEUR_V2) || eligiblePromotions.includes(promotionKeys.HSFX_BOOTSTRAP);
};
const defaultPromotion = {
  dtbOfferIds: [],
  offerIds: [],
  quantityPackOfferIdsBySkuUuid: {}
};
export const getProductPromotion = ({
  promotions
}, {
  apiName,
  versionNumber
}) => {
  const {
    productsEligibleForDirectPromotions
  } = promotions;
  return productsEligibleForDirectPromotions && productsEligibleForDirectPromotions[apiName] && productsEligibleForDirectPromotions[apiName][versionNumber] || defaultPromotion;
};
export const getPromotionExistsForApiName = ({
  promotions
}, {
  apiName
}) => {
  const {
    productsEligibleForDirectPromotions
  } = promotions;
  return !!(productsEligibleForDirectPromotions && productsEligibleForDirectPromotions[apiName]);
};
export const getPromotionForSkuId = (state, {
  skuId
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;
  const sku = skuMap[skuId];
  let versionNumber;
  if (isQuantityPackDetails(sku)) {
    const version = skuMap[sku.productVersionSkuId];
    if (isProductVersion(version)) {
      versionNumber = version.versionNumber;
    }
  } else {
    versionNumber = sku.versionNumber;
  }
  const {
    apiName
  } = getProductForSkuId(state, {
    skuId
  });
  if (!versionNumber) return null;
  return getProductPromotion(state, {
    apiName,
    versionNumber
  });
};
export const getPromotionsAreEmpty = state => {
  return !Object.keys(state.promotions).length;
};

/**
 * @deprecated - use usePurchaseableProductsForApiName hook instead
 */
export const hasAnyTBSkuInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  if (!Object.keys(state.promotions.crmSuiteOfferIds).length) {
    return true;
  }
  return false;
};

/**
 * @deprecated - use usePurchaseableProductsForApiName hook instead
 */
export const hasAnySeatsSkuInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  const coreSeatApiNames = currentOrderedPaidProductLevels.map(productLevel => CORE_SEAT_LEVEL_TO_API_NAME[productLevel]);
  return coreSeatApiNames.some(apiName => getPromotionExistsForApiName(state, {
    apiName
  }));
};
export const hasUnbundledCrmSuiteOfferIdsInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  return !!Object.keys(state.promotions.crmSuiteOfferIds).length;
};